module.exports = __webpack_public_path__ + "static/media/iconTarget.1084a721.svg";